import PermissionList from "./components/List"
import PermissionForm from "./components/Form"

let module = "permissions"

export default [
  {
    path: "permissions",
    component: PermissionList,
    meta: { module: module, permissions: ["permission-access"] }
  },
  {
    path: "permissions/create",
    component: PermissionForm,
    props: true,
    meta: { module: module, permissions: ["permission-create"] }
  },
  {
    path: "permissions/edit/:id",
    component: PermissionForm,
    props: true,
    meta: { module: module, permissions: ["permission-edit"] }
  }
]
